var obj = {
    index: function () {
        this.preloading();
        this.indexSwiper();
        this.indexBind();
    },
    preloading: function () {
        var queue = new createjs.LoadQueue();
        queue.on("progress", function (e) {
            if (e.progress * 100 >= 10) {
                $(".loading_time span").width(parseInt(e.progress * 100) + '%')
            };
            var numbers = e.progress * 100;

        }, this);
        queue.on("complete", function (e) {
            $('.loading_time').remove();
            $('.preloading').addClass('preloading-ani').fadeOut(1000);
            $('.float-time').addClass('float-time-ani')
            $('.index').removeClass('loading');
            $('.bg').addClass('bg-ani');

            setTimeout(function () {
                $('.preloading').remove();
            }, 1000);
        }, this);
        queue.loadManifest([
            '/ysjq/images/pc/m_dt_sz-cd6375bc50.png',
            '/ysjq/images/pc/m_dt_t-f09ce5bb35.png',
            '/ysjq/images/pc/m_jdt-be9954b287.png',
        ]);
    },
    // 首页轮播
    indexSwiper: function () {
        var scene = document.getElementById('scene');
        var parallax = new Parallax(scene);

        var mySwiper = new Swiper('.swiper-container', {
            direction: 'vertical',
            slidesPerView: 'auto',
            spaceBetween: 0,
            mousewheelControl: true,
            resistanceRatio: 0,
            onInit: function (swiper) {
                swiperAnimate(swiper);

                function Ani(btn, page) {
                    $(btn).on('click', function () {
                        mySwiper.slideTo(page, 500, true);
                    });
                }
                var aniLink01 = Ani('.arrow-b', '1');

            },
            onSlideChangeStart: function (swiper) {
                swiperAnimate(swiper);
                $('.footer').removeClass('footer-on');
            },
            onSlideChangeEnd: function (swiper) {
                swiperAnimate(swiper);
            },
        });

        var mySwiper2 = new Swiper('.swiper-container2', {
            loop: true,
            effect: 'coverflow',
            grabCursor: true,
            centeredSlides: true,
            nextButton: '.next',
            prevButton: '.prev',
            slidesPerView: 'auto',
            autoplayDisableOnInteraction: false,
            autoplay: 5000,
            nextButton: '.swiper-button-next',
            prevButton: '.swiper-button-prev',
            coverflow: {
                rotate: 0,
                stretch: 13,
                depth: 10,
                modifier: 12,
            }
        });
    },

    indexBind: function () {
        $('.video_btn').on('click', function (event) {
            var _this = $(this);
            var _thisData = _this.attr('data');
            var _thisSrc = _this.attr('dataSrc');
            $('#media-play-01').attr("src", _thisSrc);
            $('#media-play-01')[0].play();
            $('.popup-video').addClass('popup-video-01').fadeIn();
        });

        $('.close-btn').click(function (event) {
            $('.popup').fadeOut();
            setTimeout(function () {
                $('.popup').removeClass('popup-video-01');
                $('.popup').removeClass('popup-video-02');
            }, 500);
            $('#media-play-01')[0].pause();
        });

        $('.activity-box li').on('click', function (event) {
            $(this).addClass('show').siblings().removeClass('show');
        });

        $('.popup_wrap').click(function (event) {
            if ($(event.target)[0] == $(this)[0]) {
                $('.popup_wrap').fadeOut();
            }
        });
        
        $('.monitor-btn').on('click', function() {
            var mon_btn = $(this).attr('data-event');
            console.log('源兽崛起-pc-' + mon_btn);
            obj.countNum('源兽崛起-pc-' + mon_btn);
        })

        $('.url-btn').on('click', function() {
            var url = $(this).attr('data-url');
            setTimeout(() => {
                location.href = url;
            }, 500);
        })
    },
    // 阿里云埋点
    countNum: function (data) {
        setTimeout(() => {
            try {
                __bl.sum(data);
            } catch (e) {
                console.log(e)
            }
        }, 500);
    }
}